import { FC } from "react";
import { useRouter } from "next/router";
import Product from "../../dtos/Product.dto";
import { FooterButton } from "../StickyFooterB/StickyFooterB.styled";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { Site_url } from "../../api/config";


//Component design by Juan Tua 26/01/2022//
interface StickyFooterProps {
  data: Product;
}
const StickyFooterCityLawyers: FC<StickyFooterProps> = ({ data }) => {
  const router = useRouter();

  const geolocation = useSelector(
    (store: RootState) => store.location.geolocation
  );

  const purchaseTalktime = async () => {
    const newPath = `${Site_url}legal-consultation/checkout?min=3&concernedArea=Other%20Legal%20Problem`;
    window.location.href =  newPath;
    // router.push("/legal-consultation");
  };

  return (
    <footer
      className="footer mt-auto   text-white"
      style={{
        backgroundColor: "rgb(253, 245, 237)",
        display: "block",
        position: "fixed",
        width: "100%",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 75,
        height: 58,
        border: "2px solid #DBDDE6",
      }}
    >
      <div
        style={{
          maxWidth: 1280,
          margin: "0 auto",
          padding: " 0 15",
          height: "100%",
        }}
      >
        <div
          className="row"
          style={{ height: "100%", alignItems: "center" }}
          data-clarity-unmask="True"
        >
          <div
            style={{
              marginLeft: 20,
              flex: " 0 0 8.666667%",
              maxWidth: "16.666667%",
            }}
          >
            <img
              src="/city-lawyers/icons/call.svg"
              style={{
                width: 20,
                height: 20,
                float: "left",
                marginRight: 10,
                marginLeft: 10,
              }}
              alt="call"
            />
          </div>
          <div
            className="col-6"
            style={{ marginBottom: 10 }}
            data-clarity-unmask="True"
          >
            <span
              style={{
                textTransform: "uppercase",
                fontSize: 13.5,
                color: "#2d2d32",
                fontWeight: 500,
              }}
              data-clarity-unmask="True"
            >
              Legal Consultation @{" "}
            </span>
            <span
              style={{
                display: "inline-block",
                textTransform: "uppercase",
                fontSize: 14,
                color: "#2d2d32",
                fontWeight: 700,
              }}
              data-clarity-unmask="True"
            >
              {" "}
              {geolocation === "in" ? "₹750" : "$45"}
            </span>
            <span
              style={{ fontSize: 13.5, color: "#2d2d32", fontWeight: 500 }}
              data-clarity-unmask="True"
            >
              {" "}
              for 30 min
            </span>
          </div>
          <div className="col-4">
            <FooterButton onClick={purchaseTalktime}>Consult Now</FooterButton>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default StickyFooterCityLawyers;
